import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploader } from 'ng2-file-upload';
import { FormsModule } from '@angular/forms';
import { APP_CONTS } from '../../../app.constants';
import { ImageResizeService } from './../../../services/image-resize.service';
import { CategoriaService } from '../../../services/categoria/categoria.service';

import { Archivo } from '../../../../model/class/Archivo';
import * as _ from 'lodash';
import {ToastsManager} from 'ng2-toastr';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-edit-banner-categoria',
  templateUrl: './edit-banner-categoria.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-banner-categoria.component.css']
})
export class EditBannerCategoriaComponent implements OnInit {

  loaders = {
    image: false,
    guardar: false
  };

  newBanner: Archivo;
  parent: any;
  editando = false;
  imageFormat = APP_CONTS.FILES.IMAGE_FORMAT_STR;

  public uploader: FileUploader = new FileUploader({
    allowedMimeType:  APP_CONTS.FILES.IMAGE_FORMAT
  });

  @Input()
  set banner(banner: any) {
    if (banner.id > 0) {
      this.editando = true;
    }

    this.newBanner = banner;
  }

  @Input()
  set padre(padre: any) {
    this.parent = padre;
  }

  constructor(
    public activeModal: NgbActiveModal,
    private imageResizeService: ImageResizeService,
    private categoriaService: CategoriaService,
    private toasts: ToastsManager
  ) { }

  ngOnInit() {
  }

  onSubmit() {
    this.loaders.guardar = true;

    const prom = [];

    if (this.editando) {
      this.categoriaService.deletaArchivo(this.parent.id, this.newBanner.id)
        .subscribe(
          (resp) => {
            this.crearBanner();
          }, (error) => {
            this.toasts.error('Error al crear el Banner');
            this.loaders.guardar = false;
          }
        );
    } else {
      this.crearBanner();
    }
  }

  private crearBanner() {
    this.categoriaService.setArchivo(this.parent.id, this.newBanner.getFormData())
      .subscribe(
        (data) => {
          this.toasts.success('Banner creado');
          this.loaders.guardar = false;
          this.activeModal.close(data.data);
        }, (error) => {
          this.toasts.error('Error al crear el Banner');
          this.loaders.guardar = false;
        }
      );
  }

  asigneImage(event: any) {
    if (this.uploader.queue[this.uploader.queue.length - 1]) {
      const file = this.uploader.queue[this.uploader.queue.length - 1]._file;
      if (file) {
        this.loaders.image = true;
        this.newBanner.file = file;

        if (!this.newBanner.nombre) {
          let name = file.name.replace(/\_/g, ' ');
          name = name.replace(/-/g, ' ');
          name = name.substring(0, name.lastIndexOf('.'));
          this.newBanner.nombre = name;
        }

        this.imageResizeService.resize([file], 500, 200)
          .subscribe((result) => {
            this.loaders.image = false;
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.newBanner.previewUrl = e.target.result;
            };
            reader.readAsDataURL(result);
          });
      }
    } else {
      console.log('Archivo no valido');
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/edit-banner-categoria/edit-banner-categoria.component.ts